<div id="regua" #regua [style.left.px]="left" [style.display]="show ? 'block' : 'none'">
    <div id="ponteiro" [style.left.px]="-9">
        {{left | number : '1.0-0' }}px
    </div>
</div>
